export const GROUP_CATEGORIES = [
  'Regional',
  'Social',
  'Parenting',
  'Sports',
  'Food',
  'Professional',
  'Students',
  'Hobbies',
  'Pets',
  'Travel',
  'Other',
] as const;

export type GroupCategory = (typeof GROUP_CATEGORIES)[number];

export const CATEGORY_EMOJI: Record<string, string> = {
  Regional: '🌍',
  Social: '🎉',
  Parenting: '👶',
  Sports: '⚽',
  Food: '🍜',
  Professional: '💼',
  Students: '📚',
  Hobbies: '🎨',
  Pets: '🐾',
  Travel: '✈️',
  Other: '💬',
};

export const CATEGORY_GRADIENT: Record<string, string> = {
  Regional: 'linear-gradient(135deg, #1a3a5c 0%, #0d2035 100%)',
  Social: 'linear-gradient(135deg, #4a1a5c 0%, #2d0d35 100%)',
  Parenting: 'linear-gradient(135deg, #5c3a1a 0%, #352210 100%)',
  Sports: 'linear-gradient(135deg, #1a5c2a 0%, #0d3518 100%)',
  Food: 'linear-gradient(135deg, #5c4a1a 0%, #352c10 100%)',
  Professional: 'linear-gradient(135deg, #1a2a5c 0%, #0d1835 100%)',
  Students: 'linear-gradient(135deg, #3a1a5c 0%, #220d35 100%)',
  Hobbies: 'linear-gradient(135deg, #5c1a3a 0%, #350d22 100%)',
  Pets: 'linear-gradient(135deg, #2a5c1a 0%, #18350d 100%)',
  Travel: 'linear-gradient(135deg, #1a4a5c 0%, #0d2c35 100%)',
  Other: 'linear-gradient(135deg, #2a2a3a 0%, #18181f 100%)',
};
